export default "data:text/javascript;base64,Ly89IGxpbmtfdHJlZSAuLi9pbWFnZXMKLy89IGxpbmtfZGlyZWN0b3J5IC4uL3N0eWxlc2hlZXRzIC5jc3MK"